import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Activity = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb464__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb464__a)">
            <path
              fillRule="evenodd"
              d="M9 30v10H7a2 2 0 1 0 0 4h8a2 2 0 1 0 0-4h-2v-8h11.59l6.622 2.838A2 2 0 0 0 32 35h7q1.657 0 2.828-1.172Q43 32.657 43 31V14q0-1.657-1.172-2.828Q40.657 10 39 10h-6.59l-6.622-2.838A2 2 0 0 0 25 7H13V6a2 2 0 0 0-4 0v24Zm4-19v17h12a2 2 0 0 1 .788.162L32.41 31H39V14h-7a2 2 0 0 1-.788-.162L24.59 11H13Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
